import React from "react";
import { CommercialHero } from "@/components/commercial/CommercialHero";
import { TrucksSection } from "@/components/commercial/TrucksSection";
import { SafetyPillars } from "@/components/commercial/SafetyPillars";
import { DispatchShowcase } from "@/components/commercial/DispatchShowcase";
import { BrandShowcase } from "@/components/commercial/BrandShowcase";
import { CommercialCta } from "@/components/commercial/CommercialCta";

export default function Commercial() {
  return (
    <div data-testid="commercial-page" className="min-h-screen bg-brand-bg">
      <CommercialHero />
      <TrucksSection />
      <SafetyPillars />
      <DispatchShowcase />
      <BrandShowcase />
      <CommercialCta />
    </div>
  );
}
